import React from 'react';

// import components
import CTABanner from "components/partials/cta-banner";

// import helpers
import { getLinkDataFromDato } from "helpers/get-link-data";

const CallToActionBuilder: React.FC<{ callToActionData?: Queries.CallToActionBlockFragment }> = ({ callToActionData }) => {

    if (!callToActionData) return null;

    let bannerColorClass = `bg-brand-` + callToActionData.colorOption ?? 'teal';

    let linkData = getLinkDataFromDato(callToActionData.link?.link);

    let buttonText = linkData?.label ?? 'Error: Missing Button Text';
    let buttonUrl = linkData?.url ?? '#';
    let target = linkData?.target ?? '_self';

    let button = {
        buttonText: buttonText,
        buttonUrl: buttonUrl,
        target: target
    };

    return (
        <CTABanner
            headline={callToActionData.heading ?? ''}
            subtext={callToActionData.text ?? ''}
            bannerColorClass={bannerColorClass}
            bannerLarger={true}
            button={button}
        />
    );
};

export default CallToActionBuilder;